import { Navigate, useParams } from "react-router-dom";
import { useStore } from "@/context/StoreContext";

export const POLICY_TITLES = {
  shipping: "Shipping Policy",
  returns: "Return Policy",
  privacy: "Privacy Policy",
  terms: "Terms of Service",
};

export default function Policy() {
  const { type } = useParams();
  const { settings } = useStore();
  if (!POLICY_TITLES[type]) return <Navigate to="/" replace />;
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 pt-16 sm:pt-24" data-testid={`policy-page-${type}`}>
      <p className="eyebrow">Info</p>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tighter uppercase text-white mt-4">{POLICY_TITLES[type]}</h1>
      <div className="mt-12 text-zinc-300 leading-relaxed whitespace-pre-line text-sm sm:text-base" data-testid="policy-content">
        {settings?.policies?.[type] || ""}
      </div>
    </div>
  );
}
